// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.IconCard_scroll__GoXgh::-webkit-scrollbar {
  height: 8px;
}
.IconCard_scroll__GoXgh::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.IconCard_scroll__GoXgh::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.IconCard_IconCard__qWAgE {
  background-color: var(--bgColor);
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 272px;
  justify-content: space-between;
  text-align: center;
}
.IconCard_IconCard__CardHead__ErByq {
  width: 100%;
  margin-bottom: 22px;
}
.IconCard_IconCard__CardHead__cardHeadFilter__DE5jd {
  justify-content: space-between;
}
.IconCard_IconCard__OnlyExport__kHqST {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.IconCard_IconCard__Icon__Pa4EB {
  margin-bottom: 20px;
}
.IconCard_IconCard__Icon__Pa4EB svg {
  height: 80px;
}
.IconCard_IconCard__followerDecrease__rJHV- {
  color: var(--errorColor) !important;
}
.IconCard_IconCard__followerIcon__Qvh67 {
  scale: -1;
}
.IconCard_IconCard__followerIcon__Qvh67 path {
  fill: var(--errorColor);
}
.IconCard_IconCard__CountHolder__1ytkB {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.IconCard_IconCard__CountHolder__1ytkB span {
  color: var(--secondaryColor);
  font-size: 24px;
  font-weight: bold;
}
.IconCard_IconCard__Count__GKhNr {
  font-size: 48px !important;
  color: #606060;
  padding: 0;
  margin: 0;
  line-height: 57px;
  color: var(--mainColor);
}
body[dir=ltr] .IconCard_IconCard__Count__GKhNr {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .IconCard_IconCard__Count__GKhNr {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
@media screen and (max-width: 1600px) {
  .IconCard_IconCard__Count__GKhNr {
    font-size: 28px !important;
  }
}
.IconCard_IconCard__SmallCount__-4j2n {
  font-size: 24px !important;
  padding: 0;
  margin: 0;
  line-height: 24px;
  color: var(--mainColor);
}
body[dir=ltr] .IconCard_IconCard__SmallCount__-4j2n {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .IconCard_IconCard__SmallCount__-4j2n {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
@media screen and (max-width: 1600px) {
  .IconCard_IconCard__SmallCount__-4j2n {
    font-size: 18px !important;
  }
}
.IconCard_IconCard__upperCase__zs0WX {
  text-transform: uppercase;
}
.IconCard_IconCard__CapitalizeCase__jBaVj {
  text-transform: capitalize;
  font-size: 48px !important;
}
.IconCard_IconCard__CountName__zEIIG {
  font-size: 12px !important;
  color: #989898;
  text-transform: capitalize;
}
.IconCard_IconCard__qWAgE .IconCard_LeftToRight__CPoaE {
  direction: ltr;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/IconCard/IconCard.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AAsDF;AArDE;EACE,WAAA;EACA,mBAAA;AAuDJ;AArDI;EACE,8BAAA;AAuDN;AAnDE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAqDJ;AAlDE;EACE,mBAAA;AAoDJ;AAnDI;EACE,YAAA;AAqDN;AAlDE;EACE,mCAAA;AAoDJ;AAjDE;EACE,SAAA;AAmDJ;AAlDI;EACE,uBAAA;AAoDN;AAjDE;EACE,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAkDJ;AAjDI;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;AAmDN;AAhDE;ED2FE,0BAAA;EACA,cAAA;EC1FA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AAmDJ;AD6BI;EACE,2DAAA;AC3BN;AD6BI;EACE,2DAAA;AC3BN;AAxDI;EANF;IAOI,0BAAA;EA2DJ;AACF;AAzDE;EDmEE,0BAAA;ECjEA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AA2DJ;ADII;EACE,2DAAA;ACFN;ADII;EACE,2DAAA;ACFN;AAhEI;EANF;IAOI,0BAAA;EAmEJ;AACF;AAjEE;EACE,yBAAA;AAmEJ;AAjEE;EACE,0BAAA;EACA,0BAAA;AAmEJ;AAhEE;EDuBE,0BAAA;ECrBA,cAAA;EACA,0BAAA;AAkEJ;AAhEE;EACE,cAAA;AAkEJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.IconCard {\n  background-color: var(--bgColor);\n  padding: 20px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  height: 272px;\n  justify-content: space-between;\n  text-align: center;\n  &__CardHead {\n    width: 100%;\n    margin-bottom: 22px;\n\n    &__cardHeadFilter {\n      justify-content: space-between;\n    }\n  }\n\n  &__OnlyExport {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  &__Icon {\n    margin-bottom: 20px;\n    svg {\n      height: 80px;\n    }\n  }\n  &__followerDecrease {\n    color: var(--errorColor) !important;\n  }\n\n  &__followerIcon {\n    scale: -1;\n    path {\n      fill: var(--errorColor);\n    }\n  }\n  &__CountHolder {\n    display: flex;\n    align-items: center;\n    // margin-inline-start: 10px;\n    margin-bottom: 25px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    span {\n      color: var(--secondaryColor);\n      font-size: 24px;\n      font-weight: bold;\n    }\n  }\n  &__Count {\n    @include fontSize(48);\n    padding: 0;\n    margin: 0;\n    line-height: 57px;\n    color: var(--mainColor);\n    @media screen and (max-width: 1600px) {\n      font-size: 28px !important;\n    }\n  }\n  &__SmallCount {\n    @include fontSize(24);\n    padding: 0;\n    margin: 0;\n    line-height: 24px;\n    color: var(--mainColor);\n    @media screen and (max-width: 1600px) {\n      font-size: 18px !important;\n    }\n  }\n  &__upperCase {\n    text-transform: uppercase;\n  }\n  &__CapitalizeCase {\n    text-transform: capitalize;\n    font-size: 48px !important;\n  }\n\n  &__CountName {\n    @include fontSize(12);\n    color: #989898;\n    text-transform: capitalize;\n  }\n  .LeftToRight {\n    direction: ltr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `IconCard_scroll__GoXgh`,
	"IconCard": `IconCard_IconCard__qWAgE`,
	"IconCard__CardHead": `IconCard_IconCard__CardHead__ErByq`,
	"IconCard__CardHead__cardHeadFilter": `IconCard_IconCard__CardHead__cardHeadFilter__DE5jd`,
	"IconCard__OnlyExport": `IconCard_IconCard__OnlyExport__kHqST`,
	"IconCard__Icon": `IconCard_IconCard__Icon__Pa4EB`,
	"IconCard__followerDecrease": `IconCard_IconCard__followerDecrease__rJHV-`,
	"IconCard__followerIcon": `IconCard_IconCard__followerIcon__Qvh67`,
	"IconCard__CountHolder": `IconCard_IconCard__CountHolder__1ytkB`,
	"IconCard__Count": `IconCard_IconCard__Count__GKhNr`,
	"IconCard__SmallCount": `IconCard_IconCard__SmallCount__-4j2n`,
	"IconCard__upperCase": `IconCard_IconCard__upperCase__zs0WX`,
	"IconCard__CapitalizeCase": `IconCard_IconCard__CapitalizeCase__jBaVj`,
	"IconCard__CountName": `IconCard_IconCard__CountName__zEIIG`,
	"LeftToRight": `IconCard_LeftToRight__CPoaE`
};
export default ___CSS_LOADER_EXPORT___;
